// compare with QueryParameters in AveParkWebService.Common.Utils.Constants
export enum QueryParameter {
  QrCodeType = 't',
  QrCodeSubtype = 'st',
  QrCodeId = 'id',
  QrCodeClientId = 'cid',
  QrCodeCompanyId = 'co',
  QrCodeValue = 'value',
  QrCodeParkingSpaceNumber = 'psn',
  ZoneId = 'zoneId',
  ParkerId = 'parkerId',
}
